<div class="showcase-container row justify-content-laptop-center pt-10">
 <section class="col showcase">
   <div class="showcase-container-inner container-fluid">

    <section class="nyt-showcase" [attr.data-automation-id]="'showcase-' + showcaseType">

      <div class="row" *ngIf="hasPreviousUrl">
        <div class="col">
        <button class="nyt-back back mt-4 d-flex align-middle position-relative"
                cdkMonitorElementFocus
                (click)="goToPreviousPage()"
                [attr.data-focus-id]="'back-button'"
                data-automation-id="back-button">
          <span class="icon-back-xs d-inline-block mr-2"></span>
          <span translate class="text text-uppercase">back</span>
        </button>
        </div>
      </div>

      <div class="row pt-5 px-2 pb-4 pb-sm-9">
        <div class="header-container col-sm" data-automation-id="see-all-page-title">
          <span class="icon-{{showcaseType}} mr-3 d-inline-block text-center align-middle"
                *ngIf="showcaseType === showcasesTypes.TOPICS || showcaseType === showcasesTypes.CONTRIBUTORS"
          ></span>
          <span class="icon-related-resources mr-3 d-inline-block text-center align-middle"
                *ngIf="showcaseType === showcasesTypes.RESOURCES"
          ></span>
          <ng-container *ngIf="isAutoGeneratedShowcase; else entityTitle">
                         <ng-container [ngSwitch]="showcaseType">
                         <h3 class="title m-0 d-inline-block align-middle text-capitalize" translate *ngSwitchCase="showcasesTypes.SHELF">shelfSeeAllTitle</h3>
                         <h3 class="title m-0 d-inline-block align-middle text-capitalize" translate [translateParams]="{ value: identifier }" *ngSwitchCase="showcasesTypes.GENRE">genreSeeAllTitle</h3>
                         <h3 class="nyt-showcase__title mb-0" *ngSwitchCase="showcasesTypes.NYT">
                           <a href="https://developer.nytimes.com/" target="blank" class="nyt-showcase__link mb-n2"></a>
                           <span class="nyt-showcase__title d-block d-sm-inline mb-0"> The New York Times<sup class="nyt-showcase__reg">&reg;</sup></span>
                           <span class="nyt-showcase__title--best d-block d-sm-inline pb-3 pb-sm-0" translate> bestSellers</span>
                           <span class="nyt-showcase__title--name d-block d-sm-inline">
                           <span class="nyt-showcase__title--name_dash d-none d-sm-inline">&mdash;</span> {{ name }}</span>
                         </h3>
                         </ng-container>
                         </ng-container>
          <ng-template #entityTitle>
            <ng-container *ngIf="showcaseType !== showcasesTypes.CUSTOM; else customShowcaseTitle">
                        <ng-container *ngIf="showcaseType === showcasesTypes.CONTRIBUTORS && entity.entityType !== entityTypes.AGENT">
                        <h3 class="title m-0 d-inline-block align-middle text-capitalize" translate>contributorsSeeAllTitle</h3>
                        </ng-container>
                        <ng-container *ngIf="showcaseType === showcasesTypes.TOPICS && entity.entityType !== entityTypes.CONCEPT">
                        <h3 class="title m-0 d-inline-block align-middle text-capitalize" translate>topicsSeeAllTitle</h3>
                        </ng-container>
                        <ng-container *ngIf="showcaseType === showcasesTypes.RESOURCES && (entity.entityType !== entityTypes.INSTANCE && entity.entityType !== entityTypes.FORMAT_GROUP )">
                        <h3 class="title m-0 d-inline-block align-middle text-capitalize" translate>resourcesSeeAllTitle</h3>
                        </ng-container>
                        <ng-container *ngIf="showcaseType === showcasesTypes.RESOURCES && (entity.entityType === entityTypes.INSTANCE || entity.entityType === entityTypes.FORMAT_GROUP )">
                        <h3 class="title m-0 d-inline-block align-middle text-capitalize" translate>relatedResourcesSeeAllTitle</h3>
                        </ng-container>
                        <ng-container *ngIf="showcaseType === showcasesTypes.TOPICS && entity.entityType === entityTypes.CONCEPT">
                        <h3 class="title m-0 d-inline-block align-middle text-capitalize" translate>relatedTopicsSeeAllTitle</h3>
                        </ng-container>
                        <ng-container *ngIf="showcaseType === showcasesTypes.CONTRIBUTORS && entity.entityType === entityTypes.AGENT">
                        <h3 class="title m-0 d-inline-block align-middle text-capitalize" translate>relatedContributorsSeeAllTitle</h3>
                        </ng-container>
            </ng-container>
            <ng-template #customShowcaseTitle>
              <app-showcase-header [icon]="customShowcaseIcon" [creator]="showcaseMetadata?.creator">
                {{ !isMultipleView ? showcaseMetadata?.name : ('customShowcaseAllLibraryLists' | translate)}}
              </app-showcase-header>
            </ng-template>
          </ng-template>
        </div>
      </div>

      <div class="row px-4 px-sm-19 px-md-15">
        <ng-container *ngIf="!isLoading">
          <ng-container *ngIf="showcaseType === showcasesTypes.CONTRIBUTORS">
            <h4 class="subtitle" translate [translateParams]="{ count: totalCount, title: entity.title }">
              contributorsRelatedTo
            </h4>
          </ng-container>
          <ng-container *ngIf="showcaseType === showcasesTypes.TOPICS">
            <h4 class="subtitle" translate [translateParams]="{ count: totalCount, title: entity.title }">
              topicsRelatedTo
            </h4>
          </ng-container>
          <ng-container *ngIf="showcaseType === showcasesTypes.RESOURCES || showcaseType === showcasesTypes.SHELF || showcaseType === showcasesTypes.GENRE">
            <h4 class="subtitle" translate [translateParams]="{ count: totalCount, title: entity.title }">
              resourcesRelatedTo
            </h4>
          </ng-container>
        </ng-container>
      </div>

      <app-items-list class="row px-4 px-sm-19 px-md-15 mt-8"
        [type]="showcaseType"
        [items]="showcaseItems"
        [identifier]="identifier"
        [isMultipleView]="isMultipleView"
        [entity]="entity"
        (setFocusOnBackButton)="setFocusOnBackButton()"
        (scrollToContent)="onScrollToContent()">
      </app-items-list>

      <app-load-more-btn *ngIf="isLoadMore && !isLoading" (loadMore)="loadMore($event)" ></app-load-more-btn>
      <div *ngIf="isLoading" class="loading-spinner row justify-content-center">
        <div class="spinner-border text-primary loader-spinner"
                role="status"
                aria-live="polite">
                <span class="sr-only" translate>
                    Loading...
                </span>
        </div>
      </div>

    </section>

   </div>
 </section>
</div>
